import { Link } from "react-router-dom";
import { pages } from "../../../constants/PagePaths";
import styles from "../mainRedesign.module.scss";

const services = [
  {
    name: "설계내역",
    desc: "AI 기반 설계내역서 자동 작성",
    iconSrc: "/images/ddusul/icon/01.png",
    badge: "추천",
    badgeType: "recommend" as const,
    path: pages.costprojects + "/normal",
  },
  {
    name: "견적서",
    desc: "견적서 간편 작성 및 관리",
    iconSrc: "/images/ddusul/icon/08.png",
    badge: null,
    badgeType: null,
    path: pages.costprojects + "/estimate",
  },
  {
    name: "엑셀 자동화",
    desc: "건설 서류 엑셀 자동 변환",
    iconSrc: "/images/ddusul/icon/03.png",
    badge: "인기",
    badgeType: "popular" as const,
    path: pages.excel,
  },
  {
    name: "물량산출",
    desc: "도면 복사·붙여넣기로 자동 물량 산출",
    iconSrc: "/images/ddusul/icon/01.png",
    badge: "준비중",
    badgeType: "isNew" as const,
    path: "#",
  },
];

const quickLinks = [
  { name: "동영상 강의", path: pages.video },
  { name: "사용법 강의", path: pages.lectureroom + "/0" },
  { name: "서류 자료실", path: pages.data },
  { name: "교육 신청", path: pages.educationApplication },
];

export default () => {
  return (
    <section className={styles.servicesSection}>
      <div className={styles.sectionInner}>
        <h2 className={styles.sectionTitle}>업무 자동화 프로그램</h2>
        <p className={styles.sectionSubtitle}>
          건설 업무에 필요한 모든 프로그램을 하나의 플랫폼에서
        </p>

        <div className={styles.servicesGrid}>
          {services.map((service) => (
            <Link
              key={service.name}
              to={service.path}
              className={`${styles.serviceCard} ${service.path === "#" ? styles.serviceCardDisabled : ""}`}
              onClick={service.path === "#" ? (e) => e.preventDefault() : undefined}
            >
              {service.badge && service.badgeType && (
                <span
                  className={`${styles.serviceBadge} ${
                    styles[service.badgeType]
                  }`}
                >
                  {service.badge}
                </span>
              )}
              <div className={styles.serviceIcon}>
                <img src={service.iconSrc} alt={service.name} />
              </div>
              <div className={styles.serviceName}>{service.name}</div>
              <div className={styles.serviceDesc}>{service.desc}</div>
              <div className={styles.serviceArrow}>
                <span className="material-symbols-outlined" style={{ fontSize: 18 }}>
                  arrow_forward
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className={styles.quickLinks}>
          {quickLinks.map((link) => (
            <Link key={link.name} to={link.path} className={styles.quickLink}>
              {link.name}
              <span className="material-symbols-outlined" style={{ fontSize: 14 }}>
                north_east
              </span>
            </Link>
          ))}
        </div>

      </div>
    </section>
  );
};
